export const daysOfWeek = [
  { Id: 1, Name: 'Sunday' },
  { Id: 2, Name: 'Monday' },
  { Id: 3, Name: 'Tuesday' },
  { Id: 4, Name: 'Wednesday' },
  { Id: 5, Name: 'Thursday' },
  { Id: 6, Name: 'Friday' },
  { Id: 7, Name: 'Saturday' },
];
